import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";
import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { EmptyState } from "../molecules/EmptyState";
import SystemButton from "../SystemButton/SystemButton";

type FilteredEmptyStateProps = {
	filtered: boolean;
	onClearFilters: () => void;
	unfilteredState: ReactNode;
	dataTestId: string;
};

/** No-rows overlay that tells "no data" apart from "filters hid every row" (with Clear filters). */
export const FilteredEmptyState: FC<FilteredEmptyStateProps> = ({ filtered, onClearFilters, unfilteredState, dataTestId }) => {
	const { t } = useTranslation();
	if (!filtered) return <>{unfilteredState}</>;
	return (
		<EmptyState
			icon={<FilterAltOffOutlinedIcon />}
			title={t("filter.empty.title")}
			hint={t("filter.empty.hint")}
			action={
				<SystemButton buttonVariant="secondary" size="small" onClick={onClearFilters} noFullWidthMobile data-testid={`${dataTestId}-clear`}>
					{t("filter.empty.clear")}
				</SystemButton>
			}
			dataTestId={dataTestId}
		/>
	);
};
